var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.803 6.212c.9-4.06 5.869-5.734 8.983-2.996q.11.095.214.2.105-.105.214-.2c3.114-2.738 8.084-1.063 8.984 2.996.62 2.645-.431 4.903-1.983 6.75-1.54 1.834-3.642 3.349-5.297 4.541l-.012.009a3.27 3.27 0 0 1-3.812 0l-.011-.009c-1.656-1.192-3.758-2.707-5.298-4.54C1.233 11.115.182 8.857.803 6.213m13.132-2.131a.938.938 0 0 0-.37 1.838c.823.166 1.56.802 1.768 1.777a.937.937 0 0 0 1.834-.392 4.14 4.14 0 0 0-3.232-3.223",
    clipRule: "evenodd"
  })));
};
export default SvgHeart;